import paymentActions from "actions/payment";
import { Controller, useController, useFormContext } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { Form, Grid, Icon, Radio, Segment } from "semantic-ui-react";
import BankPaymentMethod from "./BankPaymentMethod";
import { hostedProfileSettings } from "./hostedProfileSettings";
import { PAYMENT_NETWORK_ICONS } from "shared/constants/PAYMENT_NETWORK_ICONS";
import { useRef } from "react";
import { DYL_ACCOUNT_ID } from "shared/modals/QuoteBuilderModal/helper";

const PaymentMethod = ({
    selectedPaymentMethod,
    onChangeSelectedPaymentMethod,
    account_id,
}) => {
    const isDYLAccount = Number(account_id) === DYL_ACCOUNT_ID;
    const isActive = (method) => {
        return selectedPaymentMethod === method;
    };

    const getClassName = (method) => {
        return `PaymentMethod${
            isActive(method) ? ` PaymentMethod--active` : ""
        }`;
    };

    const { control } = useFormContext();

    const { isReadingPaymentInfo } = useSelector((state) => ({
        isReadingPaymentInfo:
            state.payment.isReadingCustomerFormToken ||
            state.payment.isReadingCustomerProfile
    }));

    const dispatch = useDispatch();

    const { field: paymentMethodField } = useController({
        name: "payment_method",
        control,
    });

    const { field: termField } = useController({
        name: "term",
        control,
    });

    const [termValue] = (termField.value || "").split("/");
    const payElement = useRef();

    const onChooseBankPayment = async () => {
        onChangeSelectedPaymentMethod("bank");
        paymentMethodField.onChange({ target: { name: paymentMethodField.name, value: null } });
        await dispatch(paymentActions.resetFormToken());
        return dispatch(paymentActions.getPaymentMethods(account_id)).then((response) => {
            if (!response.profile.paymentProfiles) {
                return dispatch(
                    paymentActions.generateAcceptCustomerFormToken(
                        {
                            hostedProfileSettings: hostedProfileSettings,
                        },
                        null,
                        account_id
                    )
                ).then(() => {
                    payElement.current?.submit({ target: "add_payment" });
                })
            }
        });
    };

    const isDyl = useSelector(state => state.auth.dyl_employee);
    const isDemo = termValue === "demo";

    const doesNotRequirePayment = isDemo || isDYLAccount;
    return (
        <Segment.Group>
            {isDyl && (
                <Segment disabled={doesNotRequirePayment} className={getClassName("bank")} compact>
                    <Grid columns="equal">
                        <Grid.Column width={6}>
                            <Radio
                                disabled={doesNotRequirePayment}
                                label="Credit Card/E-Check"
                                checked={isActive("bank")}
                                onChange={onChooseBankPayment}
                            />
                        </Grid.Column>
                        <Grid.Column width={6} floated="right" textAlign="right">
                            <em>A 3% transaction fee will be added</em> <Icon color="primary" className={PAYMENT_NETWORK_ICONS.visa} /> <Icon color="primary" className={PAYMENT_NETWORK_ICONS.mastercard} /> <Icon color="primary" className={PAYMENT_NETWORK_ICONS.americanexpress} />
                        </Grid.Column>
                    </Grid>
                </Segment>
            )}
            {isActive("bank") && !isReadingPaymentInfo && (
                <Segment>
                    <BankPaymentMethod 
                        account_id={account_id}
                        onCancel={() => {onChangeSelectedPaymentMethod(null)}}
                        payElement={payElement}
                    />
                </Segment>
            )}
            <Segment disabled={doesNotRequirePayment} className={getClassName("custom-ach")} compact>
                <Radio
                    disabled={doesNotRequirePayment}
                    label="Custom (ACH)"
                    checked={isActive("custom-ach")}
                    onClick={() => {
                        const isCustomAchSelected = isActive("custom-ach");
                        onChangeSelectedPaymentMethod(isCustomAchSelected ? null : "custom-ach");
                        paymentMethodField.onChange({ target: { name: paymentMethodField.name, value: isCustomAchSelected ? "" : "custom-ach" } })
                    }}
                />
            </Segment>
            {isActive("custom-ach") && (
                <Segment style={{ minHeight: "11em" }}>
                    <Form noValidate>
                        <Controller
                            name="custom_ach"
                            control={control}
                            render={({
                                field: { name, value, onChange },
                                fieldState: { error },
                            }) => (
                                <Form.TextArea
                                    placeholder="Insert account payable information (bank, account #)"
                                    value={value}
                                    onChange={(_, { value }) => {
                                        onChange({ target: { name, value } });
                                    }}
                                    error={error?.message}
                                />
                            )}
                        />
                    </Form>
                </Segment>
            )}
        </Segment.Group>
    );
};

export default PaymentMethod;
